import React from "react"
import { createRoot } from "react-dom/client"

import "./sd-fixes.scss"
import { WithApi } from "@api"
import App from "./App"
import Sandbox from "./Sandbox"

document.addEventListener("DOMContentLoaded", () => {
  const appTarget = document.getElementById("neoJsApp")
  if (appTarget) {
    console.log("Boot App")
    const quizUid = appTarget.hasAttribute("data-quiz")
      ? (appTarget.getAttribute("data-quiz") as string)
      : undefined

    const apiPath = appTarget.hasAttribute("data-api")
      ? (appTarget.getAttribute("data-api") as string)
      : "/sandbox/api"

    createRoot(appTarget).render(
      <App quizUid={quizUid} apiPath={apiPath} />
    )
  }

  const sandboxTarget = document.getElementById("neoJsSandbox")
  if (sandboxTarget) {
    console.log("Boot Sandbox")
    createRoot(sandboxTarget).render(
      <WithApi locale="de" apiEndpoint="/sandbox/api">
        <Sandbox />
      </WithApi>
    )
  }

})
